import { render } from "./LeftMenuItem.vue?vue&type=template&id=39f369ad&scoped=true"
import script from "./LeftMenuItem.vue?vue&type=script&lang=js"
export * from "./LeftMenuItem.vue?vue&type=script&lang=js"

import "./LeftMenuItem.vue?vue&type=style&index=0&id=39f369ad&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f369ad"]])

export default __exports__